jQuery(function($){
  var $main = $(".main-site-header"),
      $headers = $(".site-header"),
      $spacer = $('<div class="header-spacer" aria-hidden="true"></div>')
        .css({ "float": "left", "width": "100%" })
        .hide()
        .insertAfter($main);

  function onScroll(){
    var stuck = window.pageYOffset >= 150;
    if (stuck && !$main.hasClass("APPLE")) {
      $spacer.css("height", $main.outerHeight()).show();
      $headers.addClass("APPLE");
    } else if (!stuck && $main.hasClass("APPLE")) {
      $headers.removeClass("APPLE");
      $spacer.hide();
    }
  }

  $(window).on("scroll", onScroll);
  onScroll();
});